import type { PosKey } from '@/types/sentence'
import { posStyle } from './posStyles'

interface PosLegendProps {
  usedPos: PosKey[]
}

export function PosLegend({ usedPos }: PosLegendProps) {
  return (
    <div className="flex flex-wrap gap-3" role="list" aria-label="Part of speech legend">
      {usedPos.map((pos) => {
        const s = posStyle(pos)
        return (
          <div key={pos} className="flex items-center gap-1.5" role="listitem">
            <span className={`inline-block h-2 w-2 rounded-sm border ${s.bg} ${s.border}`} />
            <span className="text-[11px] font-light uppercase tracking-wide text-muted">
              {s.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
